<div class="ape-drawer-inner">
  <div class="ape-drawer-head">
    <span class="ape-drawer-title">
      Incepted APE @if (period) { <span class="ape-period">{{ period }}</span> } · By providers
    </span>
    <span class="ape-drawer-count">100% = {{ total | currency: 'SGD' : 'symbol-narrow' : '1.0-0' }}</span>
  </div>

  <div class="ape-tiles">
    @for (seg of rankedSegments; track seg.name; let i = $index) {
      @if(seg.ape > 0 && seg.cases > 0){
      <div class="ape-tile" [style.--ape-i]="i">
        <span class="ape-tile-accent" [style.background]="colorAt(i)"></span>       
        <div class="ape-tile-head">
          <span class="ape-tile-logo" [style.color]="colorAt(i)"
            [style.background]="showLogo(seg) ? '#fff' : colorAt(i) + '22'"
            [class.has-logo]="showLogo(seg)">
            @if (showLogo(seg)) {
              <img [src]="seg.logoUrl" [alt]="seg.name" (error)="onLogoError(seg)" />
            } 
          </span>
          <div class="ape-tile-id">
            <span class="ape-tile-name">{{ seg.name }}</span>
            <span class="ape-tile-cases">{{ seg.cases | number }} cases</span>
          </div>
        </div>
        <div class="ape-tile-foot">
          <span class="ape-tile-ape">{{ seg.ape | currency: 'SGD' : 'symbol-narrow' : '1.0-0' }}</span>
          <span class="ape-tile-pct" [style.color]="colorAt(i)">{{ pct(seg) | number: '1.0-1' }}%</span>
        </div>
      </div>
      }
    }
  </div>
</div>
